import { gtag, isNotEmpty, toSportUrlCase } from 'utility/functions';

import { AnchorLink } from 'components/anchorLink';
import { DynamicImage, enLoading } from 'components/Image';
import { ItemWithTranslation } from 'types/swagger';
import styles from './SportQuickLinkCard.module.scss';
import { useTranslation } from 'hooks/useLingUI';

export type SportQuickLinkCardProps = ItemWithTranslation<{ disciplina?: string; manifestazione?: string }> & {
  slug?: string;
  isTop: boolean;
  iconSrc?: string;
};

export const SportQuickLinkCard = ({
  slug,
  isTop,
  iconSrc,
  disciplina,
  disciplinaTrKey,
  manifestazione,
  manifestazioneTrKey,
}: SportQuickLinkCardProps) => {
  const { t } = useTranslation();
  const disciplinaTxt = t(disciplinaTrKey, disciplina);
  const manifestazioneTxt = t(manifestazioneTrKey, manifestazione);

  return (
    <AnchorLink
      href={toSportUrlCase(`/${slug}`)}
      className={styles.container}
      onClick={() =>
        gtag({ section: 'Sport', detail: manifestazione ?? '', event: 'Click Top Manifestazione Navigation' }, true)
      }
    >
      {isTop && disciplina && (
        <span className={styles.disciplineTitle} suppressHydrationWarning={true}>
          {disciplinaTxt}
        </span>
      )}
      <div className={styles.wrapper} suppressHydrationWarning={true}>
        {isNotEmpty(iconSrc) && (
          <div className={styles.imageContainer}>
            <DynamicImage
              src={`${iconSrc}`}
              alt={manifestazioneTxt}
              width={16}
              height={16}
              loading={enLoading.lazy}
              decoding="async"
              className={styles.image}
              suppressHydrationWarning={true}
            />
          </div>
        )}
        {manifestazioneTxt}
      </div>
    </AnchorLink>
  );
};
